import { connect } from 'react-redux';
import Jumbotron from './Jumbotron';

const mapStateToProps = ({
  renderOptions: { showValueProps }
}) => ({
  showValueProps
});

export default connect(mapStateToProps, null)(Jumbotron);



// WEBPACK FOOTER //
// ./src/universal/components/Jumbotron/index.js